import React from 'react';
import { FadeIn } from '../FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroHome() {
  const whatsappLink = 'https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201.';
  // Photo card extracted so we can render it inline on mobile (between title and paragraph)
  // and as the right column on desktop
  const PhotoCard = <div className="relative mx-auto max-w-[320px] md:max-w-[380px] lg:max-w-full" data-id="element-555">
      <div className="relative rounded-[32px] overflow-hidden aspect-[3/4] shadow-2xl border-4 border-gold/30" data-id="element-556">
        <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu" className="w-full h-full object-cover object-top" data-id="element-557" />
      </div>
      <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-[radial-gradient(circle,rgba(212,175,55,0.2)_2px,transparent_2px)]" style={{
      backgroundSize: '12px 12px'
    }} data-id="element-558"></div>
    </div>;
  return <section className="relative pt-28 pb-12 md:pt-36 md:pb-20 bg-ivory overflow-hidden flex items-center" data-id="element-559">
      {/* Decorative botanical background hint */}
      <div className="absolute right-0 top-0 w-1/2 h-full opacity-20 pointer-events-none mix-blend-multiply" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1550047815-671239857d42?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80")',
      backgroundSize: 'cover',
      backgroundPosition: 'left center',
      maskImage: 'linear-gradient(to right, transparent, black)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, black)'
    }} data-id="element-560"></div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 w-full relative z-10" data-id="element-561">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-562">
          {/* Text column - centered. Mobile order: badge → title → photo → paragraph → button */}
          <div className="lg:col-span-7 flex flex-col items-center text-center" data-id="element-563">
            <FadeIn delay={0.1} data-id="element-564">
              <div className="inline-block px-5 py-2 rounded-full border border-forest/30 mb-6" data-id="element-565">
                <span className="font-display text-xs font-semibold tracking-widest uppercase text-forest" data-id="element-566">
                  NLP & CONSTELAȚII FAMILIALE
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-567">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium tracking-wide text-forest mb-6 leading-[1.2] max-w-[640px]" data-id="element-568">
                Drumul de la „funcționez" la „trăiesc". Cu structură. Cu
                blândețe. În profunzime.
              </h1>
            </FadeIn>

            {/* Photo inline on mobile only — between title and paragraph */}
            <div className="lg:hidden w-full mb-8" data-id="element-569">
              <FadeIn delay={0.3} data-id="element-570">{PhotoCard}</FadeIn>
            </div>

            <FadeIn delay={0.3} data-id="element-571">
              <p className="text-[19px] text-charcoal/80 leading-relaxed font-sans max-w-[600px] mb-10" data-id="element-572">
                Ghidez femei de carieră 30+ care se simt epuizate, fără direcție
                și deconectate de ele însele să își redobândească încrederea,
                claritatea și sensul în viață, prin metoda A.R.I.S.E.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-573">
              <div className="flex flex-col items-center gap-4" data-id="element-574">
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-forest text-ivory font-display font-medium text-[17px] hover:bg-forest-dark transition-all duration-300 shadow-lg hover:-translate-y-1 no-underline" data-id="element-575">
                  Vrei să vorbim?
                  <ArrowRight className="w-5 h-5" data-id="element-576" />
                </a>
                <p className="text-[15px] text-charcoal/60 font-sans max-w-[420px]" data-id="element-577">
                  Începem cu o sesiune cadou de 30 de minute. Fără presiune,
                  fără vânzare. Doar claritate.
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Photo column - desktop only */}
          <div className="hidden lg:block lg:col-span-5" data-id="element-578">
            <FadeIn delay={0.3} direction="left" data-id="element-579">
              {PhotoCard}
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}